import Head from 'next/head';
import { useRouter } from 'next/router';

const CanonicalUrl = () => {
  const router = useRouter();
  let canonicalUrl = `https://mypersonality.net${router.asPath}`;
  // remove trailing slash
  if (canonicalUrl.endsWith('/')) {
    canonicalUrl = canonicalUrl.slice(0, -1);
  }

  return (
    <Head>
      <link rel="canonical" href={canonicalUrl} />
    </Head>
  );
};

export default CanonicalUrl;